import React from 'react';
import type { BombiixIconProps } from './types';

/** Bombiix Single Sign-On icon. Exported from Figma (Bombiix 2026). */
const SingleSignOnIcon: React.FC<BombiixIconProps> = ({ size = 20, ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" {...rest}>
    <g>
      <g>
        <path
          d="M18.6117 20.0029C19.9517 20.0129 21.2417 19.5129 22.2317 18.6129C25.5017 15.7529 23.7517 10.0129 19.4417 9.47288C17.9017 0.132878 4.43168 3.67288 7.62169 12.5629"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.28133 12.9689C8.75133 12.6989 8.16133 12.5589 7.57133 12.5689C2.91133 12.8989 2.92133 19.6789 7.57133 20.0089"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.8213 9.88852C18.3413 9.62852 18.9013 9.48852 19.4813 9.47852"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </g>
    <path
      d="M14.423 17.5872C12.8463 17.5914 11.5647 16.3167 11.5604 14.7399C11.5561 13.1632 12.8309 11.8815 14.4076 11.8773C15.9843 11.873 17.266 13.1478 17.2703 14.7245C17.2745 16.3012 15.9998 17.5829 14.423 17.5872ZM14.423 17.5872L14.4394 23.6539C14.4399 23.851 14.2806 24.0112 14.0835 24.0117L12.2991 24.0166M14.4326 21.1558L12.2914 21.1615"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

export default SingleSignOnIcon;
